/* eslint-disable */
/**
 * Utility function to fetch search results using axios (to be replaced by api core).
 * Prashant Bhatt <pbhatt@svb.com> (svb.com)
 * Expects search Value and/or filter type
 * Returns response
 * type: success/ error
 * response: success - json result
 * response: error - error message
 */
import axios from 'axios';
import { regenTokenifExpired } from './utilityFunctions';
import searchMockService from '../ui-templates/search/searchHelpers/service';
// import { apiCall } from '@svb/api-core-component';
// import { v4 as uuidv4 } from 'uuid';

//@todo remove after testing search logic from UI - function to get search mock result from browse
const getSearchResult = async (searchValue, filterType) => {
  let apigeeHost = process.env.REACT_APP_APIGEE_HOST || '';
  const baseUrl = window.location.host;
  // Assign default ID and host
  // Assign based on URL
  if (baseUrl.includes('localhost')) {
    apigeeHost = process.env.REACT_APP_LOCAL_APIGEE_HOST;
  }

  const filterTypeData = {
    faqs: 'FAQS',
    faq: 'FAQS',
    support: 'FAQS',
    apis: 'APIS',
    api: 'APIS',
    solution: 'SOLUTIONS',
    solutions: 'SOLUTIONS',
  };
  const filterTypeQuery = filterType ? filterTypeData[filterType.toLowerCase()] : 'ALL';
  let data = JSON.stringify({
    filter_by: [filterTypeQuery],
    conditions: [
      {
        property: '*',
        operator: 'CONTAINS',
        values: [searchValue],
      },
    ],
    pagination: { limit: 100, offset: 1 },
  });
  const anontoken = regenTokenifExpired();
  const responseResults = anontoken
    .then(async (token) => {
      let config = {
        method: 'post',
        url: apigeeHost + process.env.REACT_APP_APIGEE_SEARCH_PATH,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
        data: data,
      };
      try {
        const responsedata = await axios(config);
        return responsedata.data;
      } catch (error) {
        console.log(error);
        return;
        // let mock_config = {
        //     method: 'get',
        //     url: '/search/search-sample-response.json'
        // };
        // const mockdata = await axios(mock_config);
        // return mockdata.data;
      }
    })
    .catch((err) => {
      console.log(err);
      return;
    });

  return responseResults;
};

//func to get search result from logic within UI - not to be removed
const getUISearchResult = async (searchValue, filterType, dataFromJson) => {
  const { apisDataFromJson, faqsDataFromJson, solutionsDataFromJson, resourcessDataFromJson } =
    dataFromJson;
  const filterTypeData = {
    faqs: 'FAQS',
    faq: 'FAQS',
    support: 'FAQS',
    apis: 'APIS',
    api: 'APIS',
    solution: 'SOLUTIONS',
    solutions: 'SOLUTIONS',
  };
  const filterTypeQuery = filterType
    ? filterTypeData[filterType.toLowerCase()]
      ? filterTypeData[filterType.toLowerCase()]
      : filterType
    : 'ALL';
  let data = {
    filter_by: [filterTypeQuery],
    conditions: [
      {
        property: '*',
        operator: 'CONTAINS',
        values: [searchValue],
      },
    ],
    pagination: { limit: 100, offset: 1 },
  };
  const responseResults = await searchMockService(data, {
    apisDataFromJson,
    faqsDataFromJson,
    solutionsDataFromJson,
    resourcessDataFromJson,
  });

  return responseResults;
};

export { getSearchResult, getUISearchResult };
